export default __webpack_public_path__ + "static/media/cancelcon.96116d68.svg";